import { Button } from '@heroui/react';
import { Component } from 'react';

class ErrorBoundary extends Component {
    state = { hasError: false, error: null };

    static getDerivedStateFromError(error) {
        return { hasError: true, error };
    }

    componentDidCatch(error, info) {
        // console.error('App crashed:', error, info);
    }

    handleRefresh = () => {
        // reload the page — user stays on same URL
        window.location.reload();
    };

    handleGoHome = () => {
        window.location.href = '/';
    };

    render() {
        if (this.state.hasError) {
            return (
                <div style={{
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'center',
                    justifyContent: 'center',
                    height: '100vh',
                    gap: '16px'
                }}
                    className='bg-containerBg dark:bg-[linear-gradient(135deg,_#4E5254_-300%,_#68675F_260%)]'
                >
                    <p className='text-base-text font-light'>エラーが発生しました</p>

                    <div className='flex gap-2'>
                        <Button onPress={this.handleRefresh} className='bg-button font-light text-white'>
                            ページを再読み込み
                        </Button>
                        <Button onPress={this.handleGoHome} className='bg-white/50 font-light text-base-text'>
                            ホームに戻る
                        </Button>
                    </div>

                </div>
            );
        }

        return this.props.children;
    }
}

export default ErrorBoundary;